import * as Yup from 'yup';

export const validateItemInformacionUtil = Yup.object().shape({
  titulo: Yup.string().trim().required('Campo obligatorio'),
  descripcion: Yup.string(),
});
